import { createRouter, createWebHashHistory } from 'vue-router'
import QuizList from '../views/QuizList.vue'
import Quiz from '../views/Quiz.vue'
import QuizQR from '../views/QuizQR.vue'
import Question from '../views/Question.vue'

const routes = [{
        path: '/',
        name: 'QuizList',
        component: QuizList
    },
    {
        path: '/quiz/:id',
        name: 'Quiz',
        component: Quiz,
    },
    {
        path: '/quiz/:id/qr',
        name: 'QuizQR',
        component: QuizQR
    },
    {
        path: '/quiz/:id/modules',
        name: 'QuizModules',
        component: Quiz
    },
    {
        path: '/quiz/:id/module/:modID',
        name: 'QuizModule',
        component: Question
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router